import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MainCardHeader = ({ title, titleAppend, endComponent }) => {
    return (_jsxs("div", Object.assign({ className: "main-card-header" }, { children: [_jsxs("div", Object.assign({ className: "main-card-header__title-wrapper" }, { children: [_jsx("h3", Object.assign({ className: "main-card-header__title" }, { children: title })), titleAppend !== null && _jsx("div", Object.assign({ className: "main-card-header__title-append" }, { children: titleAppend }))] })), endComponent !== null && _jsx("div", Object.assign({ className: "main-card-header__end-component-wrapper" }, { children: endComponent }))] })));
};
MainCardHeader.defaultProps = {
    titleAppend: null,
    endComponent: null,
};
